export default "__VITE_ASSET__B56NSjfl__"